










































import { Vue, Component } from 'vue-property-decorator';
import { farmStores } from '@/store/poultry/farm';
import SortIndicator from '@/components/poultry/SortIndicator.vue';

@Component({
  components: {
    SortIndicator
  }
})
export default class FarmTableHeader extends Vue {
  store = farmStores.list;

  sort(sortType: any) {
    this.store.setSortType(sortType);
  }

  get currentSort() {
    return this.store.currentSort;
  }

  get currentSortOrder() {
    return this.store.currentSortOrder.reverse;
  }
}
